module.exports = __webpack_public_path__ + "static/img/14000124.97071646.png";